define('models/Claim',[
	'core/can',
	'models/Session',
	'models/Base',
	'models/Patient',
	'models/PatientStatus',
	'models/Physician',
	'models/ConditionCode',
	'models/OccurrenceCode',
	'models/ValueCode',
	'models/DiagnosisCode',
	'models/ServiceLine',
	'moment'
], function(can, Session, Base, Patient, PatientStatus, Physician, ConditionCode, OccurrenceCode, ValueCode, DiagnosisCode, ServiceLine, moment) {
	
	function makeProviderCompute(ProviderType) {
		return can.compute(function(provider) {
			if (provider) {
				this.setProvider(provider);
			} else {
				return this.getProvider(ProviderType)
			}
		});
	}
	
	return Base.extend({
		
		findOne: 'GET /Claim/{id}',
		findAll: 'GET /Claim/List',
		create: 'POST /Claim',
		update: 'PUT /Claim',
		destroy: 'DELETE /Claim/{id}',

		adjustClaim: function(params, success, error) {
			return can.ajax({
				type: 'PUT',
				url: '/Claim/Adjust',
				data: params
			}).then(success, error);
		},

		suppressClaim: function(params, success, error) {
			return can.ajax({
				type: 'PUT',
				url: '/Claim/Suppress',
				data: params
			}).then(success, error);
		},
		
		findUB04: function(params, success, error) {
			can.ajax({
				type: 'POST',
				url: '/SingleUseTicket'
			}).then(function(data) {
				var url = can.sub('/Document/{id}/UB04', params);
				window.location = config.api_url + url + '?ticket=' + data.Ticket;
			}).then(success, error);
		}
	},{
	
		define: {
			Status: {
				value: 0	
			},
			ProviderId: {
				value: function() {
					// if account only has one provider, default to that provider
					var providers = Session.attr('Providers');
					return (providers.length === 1) ? providers.attr('0._id') : undefined;
				}
			},
			TypeOfBill: {
				type: 'string'	
			},
			Patient: {
				Type: Patient
			},
			AdmissionType: {
				type: 'number',
			},
			AdmissionSource: {
				type: 'number'
			},
			PatientStatus: {
				type: 'number',
				value: 0
			},
			Providers: {
				Type: Physician.List,
				value: []
			},
			ConditionCodes: {
				Type: ConditionCode.List,
				value: []
			},
			OccurrenceCodes: {
				Type: OccurrenceCode.List,
				value: []
			},
			OccurrenceSpanCodes: {
				Type: OccurrenceCode.List,
				value: []
			},
			ValueCodes: {
				Type: ValueCode.List,
				value: []
			},
			DiagnosisCodes: {
				Type: can.Map.extend({
					define: {
						Principal: {
							Type: DiagnosisCode,
							value: {}
						},
						Admitting: {
							Type: DiagnosisCode,
							value: {}
						},
						Reason: {
							Type: DiagnosisCode.List,
							value: []
						},
						External: {
							Type: DiagnosisCode.List,
							value: []
						},
						Other: {
							Type: DiagnosisCode.List,
							value: []
						}
					},
					isEmpty: can.compute(function() {
						return !(this.attr('Principal.Code') 
							|| this.attr('Admitting.Code')
							|| this.attr('Reason.length') > 0
							|| this.attr('External.length') > 0
							|| this.attr('Other.length') > 0);
					})
				}),
				value: {}
			},
			ServiceLines: {
				Type: ServiceLine.List,
				value: [{RevenueCode:'0023'}]
			},
			TreatmentAuthorizationCodes: {
				value: []
			}
		},
		
		_Provider: can.compute(function() {
			var provider = Session.attr('Providers').findById(this.attr('ProviderId'));
			return provider;
		}),

		_AccountId: can.compute(function() {
			var provider = Session.attr('Providers').findById(this.attr('ProviderId'));
			return provider ? provider.attr('AccountId') : '';
		}),
		
		_PatientName: can.compute(function() {
			var first = this.attr('PatientName.First'),
				last = this.attr('PatientName.Last');
			if (first && last) {
				return last + ', ' + first;
			} else {
				return last || first || undefined;
			}
		}),
		
		_TypeOfClaim: can.compute(function() {
			var typeofClaim = (this.attr('StartDate') === this.attr('EndDate')) ? 'RAP' : 'Final';
			
			switch (parseInt(this.attr('TypeOfClaim'), 10)) {
				default:
				case 0: return 'None';
				case 1: return typeofClaim; 
				case 2: return typeofClaim;
				case 10: return 'HCFA';
			}
			
		}),
		
		_TypeOfBill: can.compute(function() {
			var tob = this.attr('TypeOfBill');
			if (tob === undefined) return undefined;
			switch (tob) {
				case '320': 
				case '330':
					return this.attr('_TypeOfClaim') + ' (Rejected)';
				case '32A':
					return 'NOA' 
				case '32D':
					return 'Void/Cancel Prior NOA/Claim' 
				case '322': 
				case '332':
					return 'RAP';
				case '327':
				case '337':
					return 'Adjustment';
				case '328':
				case '338':
					return this.attr('_TypeOfClaim') + ' (Canceled)';
				case '329':
				case '339':
					return 'Final';
				case '32F':
				case '33F':
					return 'Contractor Adjustment';
				case '32I':	case '33I':
				case '32G': case '33G': 
				case '32H': case '33H':
				case '32J': case '33J': 
				case '32K': case '33K': 
				case '32M': case '33M': 
				case '32P': case '33P':
					return 'Intermediary Review';
					// return tob;
				case '341':
					return 'Outpatient';
				default:
					return 'Unknown';
			}
		}),
	
		_Status: can.compute(function() {
			switch (this.attr('Status')) {			
				case 0: return 'Unsubmitted'; 	// Created but not yet submitted 
				case 1: return 'Pending'; 		// Claim is in queue to submit
				case 2: return 'Processing'; 	// Claim is processing (in DDE)
				case 3: return 'Returned'; 		// Claim has returned
				case 4: return 'Updated'; 		// User has created or updated the claim
				case 5: return 'Errored'; 		// Encountered error when scraping
				case 6: return 'Canceling';		// Claim submitted for cancellation
				case 7: return 'Suppressing';	// Claim submitted for suppression
			}
		}),
	
		_isValidStatus: can.compute(function() {
			if(this.attr('StatusCode') == 'S')
			{
				var locationCode = this.attr('LocationCode');
				var letter = locationCode.substring(0,1);
				var numbers = parseInt(locationCode.substring(1, 5));
				
				if(letter === "B" && (6000 <= numbers && numbers <= 6001 || 9000 <= numbers && numbers <= 9099)){
					return false;
				}
			}

			return true;
		}),

		_isAdr: can.compute(function() {
			if(this.attr('StatusCode') == 'S')
			{
				var locationCode = this.attr('LocationCode');
				var letter = locationCode.substring(0,1);
				var numbers = parseInt(locationCode.substring(1, 5));
				
				if(letter === "B" && (6000 <= numbers && numbers <= 6001)){
					return true;
				}
			}

			return false;
		}),

		_MedicareStatus: can.compute(function() {
			switch (this.attr('StatusCode')) {
				
				case 'S': 
					if (!!~['B6000','B6001','M50MR'].indexOf(this.attr('LocationCode')))
						return 'ADR';
					
					return 'Suspense';
					
				case 'P': 
					//switch (this.attr('LocationCode')) {
					//	case 'B9996':
					//		return 'Processing'; 
					//	case 'B9997':
							return 'Paid';
					//}
				case 'R': return 'Rejected';
				case 'D': return 'Denied';
				case 'T': return 'RTP';
				
				// Other
				case 'A': return 'Good';
				case 'I': return 'Inactive';
				case 'M': return 'Manual Move';
				case 'U': return 'RTP';
			}
		}),
		
		_MedicareStatusLocation: can.compute(function() {
			return this.attr('StatusCode') + ' ' + this.attr('LocationCode');
		}),
		
		_CoverageType: can.compute(function() {
			switch (this.attr('CoverageType')) {	
				case 0: return 'None';
				case 1: return 'TricareChampus';
				case 2: return 'Medicare';
				case 3: return 'Medicaid';
				case 4: return 'ChampVA';
				case 5: return 'FECABlkLung';
				case 6: return 'GroupHealthPlan';
				case 7: return 'Other';
			}
		}),
		
		// Type of Admission
		// UB04 Field Locator 14
		_AdmissionType: can.compute(function() {
			switch (this.attr('AdmissionType')) {
				case 1: return 'Emergency';
				case 2: return 'Urgent';
				case 3: return 'Elective';
				case 4: return 'Newborn';
				case 5: return 'Trauma';
				case 9: return 'Information Not Available';
			}
		}),
		
		// Source of Admission
		// UB04 Field Locator 15
		_AdmissionSource: can.compute(function() {
			// In the Case of Newborn
			// 1 = Normal Delivery
			// 2 = Premature Delivery
			// 3 = Sick Baby
			// 4 = Extramural Birth
			switch (this.attr('AdmissionSource')) {
				case 1: return 'Physician Referral';
				case 2: return 'Clinic Referral';
				case 3: return 'HMO Referral';
				case 4: return 'Transfer from Hospital';
				case 5: return 'Transfer from Skilled Nursing Facility'; // SNF
				case 6: return 'Transfer From Another Health Care Facility';
				case 7: return 'Emergency Room';
				case 8: return 'Court/Law Enforcement';
				case 9: return 'Information Not Available';
			}
		}),
		
		// Patient Discharge Status
		// UB04 Field Locator 17
		_PatientStatusCode: can.compute(function() {
			var v = this.attr('PatientStatus'), o = PatientStatus[v];
			return (o !== undefined) ? o.code : undefined;
		}),
		
		_PatientStatusDescription: can.compute(function() {
			var v = this.attr('PatientStatus'), o = PatientStatus[v];
			return (o !== undefined) ? o.desc : undefined;
		}),
		_Icd9EndDate: '2015-09-30',

		_isIcd10: can.compute(function() {
			var startDate = this.attr('StartDate'),
				icd9EndDate = this.attr('_Icd9EndDate');
			return startDate 
					&& (moment.utc(startDate).isAfter(icd9EndDate));
		}),

		_isIcd9: can.compute(function() {
			var startDate = this.attr('StartDate'),
				icd9EndDate = this.attr('_Icd9EndDate');
			return startDate 
					&& (moment.utc(startDate).isBefore(icd9EndDate)); // isBefore is <=
		}),

		// TODO make this "compute" work
		/*TypeOfDiagnosis: can.compute(function (newVal) {
			// var endDate = this.attr('EndDate');

			if(newVal !== undefined) {
				return newVal;
			} else {
				if(this.attr('_isIcd10')) {
					return 'icd10';
				} else if(this.attr('_isIcd9')) {
					return 'icd9';
				} else {
					return 'Neither';
				}
			}

			return null;
		}),*/

		_isIcd10Error: can.compute(function() {
			return (this.attr('_isIcd10') 
					&& (this.attr('TypeOfDiagnosis') 
						&& this.attr('TypeOfDiagnosis') === 'icd9'));
		}),

		_isIcd9Error: can.compute(function() {			
			return (this.attr('_isIcd9') 
					&& (this.attr('TypeOfDiagnosis') 
						&& this.attr('TypeOfDiagnosis') === 'icd10'));
		}),
		
/*
		_ConditionRelatedTo: can.compute(function() {
			switch (this.attr('ConditionRelatedTo')) {
				case 0: return 'Employment';
				case 1: 'AutoAccident';
				case 2: 'Other';
			}
		}),
*/
		
		// --------------------------------------------------
		// State
		// --------------------------------------------------
		
		_isEditable: can.compute(function() {
			var status = this.attr('Status');

			// The following are the criteria to edit:
			// 1. Claim is in unsubmitted status
			// 2. Claim is in pending status and the user is an impersonator
			// 2. Claim is in errored status
			// 3. Claim is resubmittable 
					// AND there is an end date 
					// AND it is within 1 year from the end date
			return (status === 0)
				|| this.attr('_isSpecial')
				|| (status === 5)
				|| (
					this.attr('_isSuppressible')
					|| this.attr('_isErrorTob')
					&& this.attr('_isWithinDeadline')
					);
			
		}),

		_isSpecial: can.compute(function() {
			return (this.attr('Status') === 1
					&& Session.attr('isImpersonating')
					&& this.attr('TypeOfBill') !== '327');
					
		}),

		// Error tob only if a claim is rejected (320), cancelled (328) and only error tob is resubmittable
		_isErrorTob: can.compute(function() {
			return (!!~['320','328'].indexOf(this.attr('TypeOfBill')));
		}),
		
		//  RAP (322), NOA (32A), Adjustment (327), final (329) and Outpatient (341)) in RTP status can change tob even they have ReceivedDate
		_isTobChangable: can.compute(function() {
			return !this.attr('_isSubmitted') || (this.attr('StatusCode') === 'T' && (!!~['322','32A','327','329','341'].indexOf(this.attr('TypeOfBill'))));
		}),
		
		_isPaid: can.compute(function() {
			return (this.attr('StatusCode') === 'P')
					&& (this.attr('LocationCode') === 'B9997' || this.attr('LocationCode') === 'B9996')
					&& !this.attr('_isErrorTob');
		}),
		
		_isLocked: can.compute(function() {
			if(!this.attr('_isWriteAllowed')) {
				return true;
			} else if (!this.attr('_isSubmitted')) {
				return false;
			} else {
				return !(this.attr('_isEditable')
						|| this.attr('_isAdjustable')
						|| (this.attr('TypeOfBill') === '327'
							&& this.attr('Status') !== 1)
						) || (this.attr('StatusCode') === 'T'
							&& this.attr('LocationCode') === 'B9900');
			}
		}),

		_isWithinDeadline: can.compute(function() {
			var rawEndDate = this.attr('EndDate');

			if(rawEndDate) {
				var endDate = moment.utc(rawEndDate);

				// If RAP add 59 days to the end date
				// This is to check the claim's resubmission deadline
				if(this.attr('_IsRap')){
					endDate = endDate.add(59, 'days');
				}

				return moment().isBefore(endDate.add(1, 'y'));
			}

			return false;
		}),

		_isWriteAllowed: can.compute(function () {
			return App.isActionAllowed('ClaimsWrite');
		}),

		// Claim will be locked for the following reasons:
		// 1. Status is Pending(1), Processing (2) and Canceling (6)
		// 2. Episode end date is more than a year old
		// 3. Medicare Status is suspense 
		// 4. Medicare Status is paid and type of bill 322, 32A, 327 and 329
		_lockReason: can.compute(function() {
			var message  = "Claim is locked because ";
			
			if(this.attr('_isLocked')) {
				if(!this.attr('_isWriteAllowed')) {
					return message + "you do not have the edit permission.";
				}

				if(!this.attr('_isWithinDeadline')) {
					return message + "the episode end date is more than a year old.";
				}

				if(this.attr('_MedicareStatus') === 'Suspense') {
					return message + "it is in Suspense status.";
				} 

				if(this.attr('StatusCode') === 'T' && this.attr('LocationCode') === 'B9900') {
					return message + "you cannot modify a claim in T B9900."
				}

				if(this.attr('_MedicareStatus') === 'Paid') {
					message += ' it has been paid';

					if(this.attr('_isWriteAllowed') 
						&& this.attr('CancelDate') === undefined 
						&& this.attr('_isProcesingCancel') === undefined 
						&& !!~['322','32A','327','329'].indexOf(this.attr('TypeOfBill'))) {
						message += ' and can only be canceled';
					}
					
					return message + '.';

				}

				if(this.attr('Status') > 0) {

					switch(this.attr('Status')) {
						case 1: return message + "it is currently being submitted.";
						case 2: return message + "it is currently being processed.";
						case 6: return message + "it is currently being canceled.";
					}

				}
			}
		}),
		
		_isSubmitted: can.compute(function() {
			return this.attr('ReceivedDate') !== undefined && this.attr('ReceivedDate') !== null;
		}),
		
		_isPending: can.compute(function() {
			return this.attr('Status') === 1;
		}),
		
		_isUpdated: can.compute(function() {
			return this.attr('Status') === 4;
		}),

		_isErrored: can.compute(function() {
			return this.attr('Status') === 5;
		}),

		_isAdjustable: can.compute(function() {
			return (this.attr("_isPaid") && this.attr('TypeOfBill') === '329') || this.attr('_isPostPayReview');
		}),

		_isPostPayReview: can.compute(function() {
			return (this.attr('StatusCode') === 'R' && this.attr('LocationCode') === 'B7516');
		}),

		_isSuppressible: can.compute(function() {
			return this.attr('StatusCode') === 'T' && this.attr('Status') !== 1  && this.attr('TypeOfBill') !== '328';
		}),

		_isSuppressing: can.compute(function() {
			return this.attr('Status') === 7;
		}),

		_isProcesingCancel: can.compute(function() {
			return this.attr('Status') === 6;
		}),

		_IsRap: can.compute(function() {
			return this.attr('TypeOfClaim') === 1;
		}),

		_PaidAmount: can.compute(function() {
			return (this.attr('TypeOfBill') === '328') ? -1 * this.attr('PaidAmount') : this.attr('PaidAmount');
		}),
		
		// --------------------------------------------------
		// Provider Aliases
		// --------------------------------------------------
		
		_BillingProvider: 			makeProviderCompute(0),
		_PayToProvider: 			makeProviderCompute(1),
		_ServiceFacilityProvider:	makeProviderCompute(2),
		_AttendingPhysician: 		makeProviderCompute(3), // UB04 78
		_ReferringPhysician: 		makeProviderCompute(4), 
		_OperatingPhysician: 		makeProviderCompute(5), // UB04 79
		_RenderringPhysician: 		makeProviderCompute(6),
		_OtherPhysician1: 			makeProviderCompute(7), // UB04 80
		_OtherPhysician2: 			makeProviderCompute(8), // UB04 81
		
		getProvider: function(type) {
			
			var p = this.attr('Providers');
			
			if (p !== undefined) {
				
				for (var i=0; i<p.attr('length'); i++)
					if (p.attr(i).attr('ProviderType') === type)
						return p.attr(i);
				
				// Provider does not exist, so we'll make one.
				var np = new Physician({ 
					ProviderType: type,
					Name: {}
				});
				p.push(np);
				return np;
			}
		},
		
		setProvider: function(np) {
			
			// Get current provider with provider type
			var cp = this.getProvider(np.attr('ProviderType'));
			
			// If current provider is not set, push to Providers
			// Otherwise, update current provider
			if (cp === null) {
				this.attr('Providers').push(np);
			} else {
				cp.attr(np.attr(), true);
			}
		},
		
		// --------------------------------------------------
		// Methods
		// --------------------------------------------------
		
		getUB04: function() {
			// TODO no guarantees the claim has an id!
			var id = this.attr('_id');
			if (id !== undefined)
				this.constructor.findUB04({ id:id });
		},

		adjust: function(success, error) {
			return this.constructor.adjustClaim(this.attr(), success, error);
		},

		suppress: function(success, error) {
			return this.constructor.suppressClaim(this.attr(), success, error);
		},
		
		clone: (function(cloneKeys) {
			return function() {
				
				var copy = this.attr(),
					clone = new this.constructor;
				
				// copy specified attributes from copy to clone
				for (var i=0; i<cloneKeys.length; i++) {
					clone.attr(cloneKeys[i], copy[cloneKeys[i]]);
				}
				
				// RAP or Final?
				var hasDates = copy.StartDate && copy.EndDate,
					equalDates = copy.StartDate === copy.EndDate;
				if (copy.TypeOfClaim===1 || (hasDates && equalDates)) {
					clone.attr({
						TypeOfBill: '322',
						TypeOfClaim: 1
					});
				} else if (copy.TypeOfClaim===2 || (hasDates && !equalDates)) {
					clone.attr( {
						TypeOfBill: '329',
						TypeOfClaim: 2
					});
				}
				
				// Dolly is name of the first sheep ever cloned
				clone.dolly = copy.EntityId;
				
				return clone;
			}
		})([
			'ProviderId',
			'StartDate',
			'EndDate',
			'HicNumber',
			'Patient',
			'AdmissionDate',
			'AdmissionSource',
			'AdmissionType',
			'PatientStatus',
			'ConditionCodes',
			'OccurrenceCodes',
			'OccurrenceSpanCodes',
			'ValueCodes',
			'ServiceLines',
			'DiagnosisCodes',
			'Providers',
			'TreatmentAuthorizationCodes',
			'Remarks'
		])
	});
	
});
